import '@styles/index.scss'
import '@styles/found.scss'

import './utils/generalModules'

import './modules/togglePreferences'
import './modules/search-by'